import React from 'react';

const DateHeader = ({ date }) => {
  const formatDate = (dateString) => {
    const messageDate = new Date(dateString);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    
    // Reset time part for comparison
    today.setHours(0, 0, 0, 0);
    yesterday.setHours(0, 0, 0, 0);
    const msgDate = new Date(messageDate);
    msgDate.setHours(0, 0, 0, 0);
    
    // Check if today
    if (msgDate.getTime() === today.getTime()) {
      return 'Today';
    }
    
    // Check if yesterday
    if (msgDate.getTime() === yesterday.getTime()) {
      return 'Yesterday';
    }
    
    // Check if within the last 7 days
    const daysDiff = Math.floor((today - msgDate) / (1000 * 60 * 60 * 24));
    if (daysDiff < 7) {
      return messageDate.toLocaleDateString('en-US', { weekday: 'long' });
    }
    
    // For older dates
    return messageDate.toLocaleDateString('en-US', { 
      month: 'long', 
      day: 'numeric',
      year: messageDate.getFullYear() !== today.getFullYear() ? 'numeric' : undefined
    });
  };

  return (
    <div className="flex justify-center my-4">
      <div className="bg-gray-200 px-4 py-1 rounded-full text-xs text-gray-600 font-medium">
        {formatDate(date)}
      </div>
    </div>
  );
};

export default DateHeader;
